module.exports = __webpack_public_path__ + "img/wanglianzhong.29349094.jpg";